module.exports = __webpack_public_path__ + "img/icon_sm_ccpck.2e31185d.png";